/* sb W26 SELECT LENSES — buy box das PDPs RX (porta o comportamento da original):
   "Starting at" (frame + lente Clear), botões SELECT LENSES (abre o wizard wmp-prescription-flow)
   e SHOP IN RX SUN (versão sunglasses da mesma cor); esconde preço/quantidade/ATC nativos do frame.
   Preços sempre do NOSSO catálogo (Liquid no load + /products/<h>.js ao abrir o wizard). */
(function () {
  "use strict";
  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var cfg = readJSON("sb-rx-lenses-cfg");
  var vcfg = readJSON("wmp-variants-config");
  if (!cfg || !vcfg) return;
  var variants = {};
  (vcfg.variants || []).forEach(function (v) { variants[String(v.id)] = v; });

  function fmt(c) {
    if (window.WmpStore && typeof window.WmpStore.formatPrice === "function") return window.WmpStore.formatPrice(c);
    return "$" + (Number(c || 0) / 100).toFixed(2);
  }
  function mainForm() {
    return document.querySelector('#MainContent product-form.main-product-form') ||
      document.querySelector('#MainContent product-form[data-main="true"]');
  }
  function currentVariantId() {
    var f = mainForm();
    var inp = f && f.querySelector('input[name="id"]');
    var id = inp && inp.value;
    if (!id || !variants[id]) {
      try { id = new URL(location.href).searchParams.get("variant") || id; } catch (e) {}
    }
    if (!id || !variants[id]) {
      var root = document.getElementById("wmp-prescription-flow");
      id = root && root.getAttribute("data-product-variant-id");
    }
    return String(id || "");
  }

  var startEl, sunEl, lastVid = null;

  function render() {
    var vid = currentVariantId();
    var v = variants[vid];
    if (!v) return;
    if (startEl) {
      startEl.querySelector(".sb-rx-starting__price").textContent = fmt(v.priceCents + (Number(cfg.lensStart) || 0));
    }
    if (sunEl && cfg.sunUrl) {
      var sid = null;
      (cfg.sun || []).some(function (pair) { if (pair[0] === v.color) { sid = pair[1]; return true; } return false; });
      sunEl.setAttribute("href", cfg.sunUrl + (sid ? "?variant=" + sid : ""));
    }
    lastVid = vid;
  }

  function build() {
    var f = mainForm();
    if (!f) return false;
    var info = f.closest(".product__info-container") || f.parentElement;
    if (!info || info.querySelector(".sb-rx-buttons")) return true;
    // bloco do ATC nativo = filho direto do info que contém o product-form
    var atcBlock = f;
    while (atcBlock.parentElement && atcBlock.parentElement !== info) atcBlock = atcBlock.parentElement;
    var price = info.querySelector(".product-page-price") || info.querySelector('[id^="price-"]');
    var qty = info.querySelector(".product-form__quantity");

    startEl = document.createElement("div");
    startEl.className = "sb-rx-starting";
    startEl.innerHTML = '<span class="sb-rx-starting__label">Starting at</span> <span class="sb-rx-starting__price"></span>';
    if (price) { price.classList.add("sb-rx-hide"); price.parentNode.insertBefore(startEl, price.nextSibling); }
    else info.insertBefore(startEl, info.firstChild);
    if (qty) qty.classList.add("sb-rx-hide");

    var box = document.createElement("div");
    box.className = "sb-rx-buttons";
    box.innerHTML = '<button type="button" class="sb-rx-btn sb-rx-select select-lenses" aria-label="Select lenses" data-wmp-open>Select Lenses</button>' +
      (cfg.sunUrl ? '<a class="sb-rx-btn sb-rx-sun" href="' + cfg.sunUrl + '">Shop in RX Sun</a>' : "");
    atcBlock.classList.add("sb-rx-hide");
    atcBlock.parentNode.insertBefore(box, atcBlock.nextSibling);
    sunEl = box.querySelector(".sb-rx-sun");
    render();
    return true;
  }

  // sincroniza a armação escolhida na PDP com o wizard (antes do wmp-app abrir o overlay)
  function syncStore() {
    var st = window.WmpStore;
    var v = variants[currentVariantId()];
    if (!st || !v) return;
    var p = st.get("product") || {};
    p.variantId = String(v.id); p.variant = v.color || v.title; p.price = v.priceCents;
    p.compare = v.comparePriceCents || 0; p.image = v.image || p.image;
    st.set("product", p);
    var pr = st.get("pricing") || {};
    pr.frame = v.priceCents;
    st.set("pricing", pr);
    var root = document.getElementById("wmp-prescription-flow");
    if (root) root.setAttribute("data-product-variant-id", String(v.id));
    document.querySelectorAll(".wmp-flow__product-variant, .wmp-flow__mobile-product-variant").forEach(function (el) { el.textContent = p.variant; });
    if (v.image) document.querySelectorAll(".wmp-flow__product-image img, .wmp-flow__mobile-thumb").forEach(function (im) { im.src = v.image; im.removeAttribute("srcset"); });
  }

  // preços das lentes = NOSSO catálogo ao vivo (o config nasce com os valores do Admin; aqui só confirma)
  var refreshed = null;
  function refreshPrices() {
    if (refreshed) return refreshed;
    var hs = (cfg.handles || []).slice(), res = {};
    function one(h) {
      return fetch("/products/" + h + ".js", { credentials: "same-origin" })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { if (j && j.variants && j.variants[0]) res[h] = j.variants[0]; })
        .catch(function () {});
    }
    var queue = hs.slice(), workers = [];
    for (var w = 0; w < 6; w++) workers.push((function next() { var h = queue.shift(); return h ? one(h).then(next) : Promise.resolve(); })());
    refreshed = Promise.all(workers).then(function () {
      var c = window.WmpProductsConfig;
      if (!c) return;
      function upd(o, h) {
        var v = res[h]; if (!v || !o) return;
        o.variantId = v.id; o.priceCents = v.price;
        o.comparePriceCents = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : 0;
      }
      (c.lensPackages || []).concat(c.lensTypes || []).forEach(function (o) { upd(o, o.sourceHandle); });
      (c.accessories || []).forEach(function (o) { upd(o, o.key); });
      if (c.getPrism && c.getPrism()) upd(c.getPrism(), "prizm");
      if (res[cfg.startHandle]) { cfg.lensStart = res[cfg.startHandle].price; render(); }
    });
    return refreshed;
  }

  document.addEventListener("click", function (e) {
    var t = e.target.closest && e.target.closest("[data-wmp-open]");
    if (!t) return;
    syncStore();
    refreshPrices();
  }, true);

  function start() {
    if (!build()) { var n = 0, iv = setInterval(function () { if (build() || ++n > 40) clearInterval(iv); }, 250); }
    setInterval(function () { if (currentVariantId() !== lastVid) render(); }, 400);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();
